<template>
    <div style="line-height: 0px;">
        <el-form :inline="true" style="text-align: center;">
            <el-form-item>
                <el-input
                        v-model="searchForm.casename"
                        placeholder="元素名称"
                        clearable
                >
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button @click="getCaseList">搜索</el-button>
            </el-form-item>

        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :height='700'
                border
                stripe
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>

            <el-table-column
                    prop="id"
                    label="id"
                    width="120">
            </el-table-column>

            <el-table-column
                    prop="casename"
                    label="模版名称"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="caseurl"
                    label="模块地址"
                    show-overflow-tooltip>
            </el-table-column>

<!--            <el-table-column-->
<!--                    prop="created"-->
<!--                    label="创建时间"-->
<!--                    :formatter="dateFormat"-->
<!--                    width="200px">-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="created"
                    width="200"
                    label="创建时间">
                 <template slot-scope='scope'>
                    <span>{{ scope.row.created}}</span>
                </template>
            </el-table-column>

            <el-table-column
                    prop="icon"
                    label="操作">

                <template slot-scope="scope">

                    <el-button @click="editHandle(scope.row.id)" type="text">查看详情</el-button>

                </template>
            </el-table-column>

        </el-table>
        <el-drawer
                title="结果详情"
                :visible.sync="drawer"
                :direction="direction"
                :before-close="handleClose"
                size="90%">
            <el-table
                    ref="multipleTable"
                    :data="tablePmModCaseInfoData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    stripe
                    @selection-change="handleSelectionChange">

                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>

                <el-table-column
                        prop="modulelocation"
                        label="模版名称"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="elementname"
                        label="元素名称"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="locationtype"
                        label="元素定位方式"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="locationvalue"
                        label="元素定位值"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="operationtype"
                        label="操作元素方式"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="datatype"
                        label="输入值数据类型"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="elementdesc"
                        label="描述"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="elementimg"
                        label="截图"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-popover
                                placement="right"
                                trigger="hover">
                            <img :src="$host+scope.row.elementimg"/>
                            <img slot="reference" :src="$host+scope.row.elementimg"  style="max-height: 100%;max-width: 100%">
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="url"
                        label="请求地址"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="code"
                        label="HTTP状态"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="consolelog"
                        label="控制台信息"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.consolelog !== null">
                            <el-popover
                                    placement="right"
                                    trigger="hover"
                                    :content="scope.row.consolelog">
                                <el-button slot="reference" text="scope.row.consolelog" style="color:red;">详情错误</el-button>
                            </el-popover>
                        </div>
                    </template>

                </el-table-column>
                <el-table-column
                        prop="statu"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag size="small" v-if="scope.row.statu === 1" type="success">通过</el-tag>
                        <el-tag size="small" v-else-if="scope.row.statu === 0" type="danger">失败</el-tag>
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="icon"-->
                        <!--label="操作">-->

                    <!--<template slot-scope="scope">-->

                        <!--<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>-->
                        <!--<el-divider direction="vertical"></el-divider>-->

                        <!--<template>-->
                            <!--<el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">-->
                                <!--<el-button type="text" slot="reference">删除</el-button>-->
                            <!--</el-popconfirm>-->
                        <!--</template>-->

                    <!--</template>-->
                <!--</el-table-column>-->

            </el-table>

            <!--<div style="display: flex; flex-flow: row wrap;">-->
                <!--<el-card style="margin: 0 10px 10px 0;" >-->
                    <!--<div style="padding: 14px;" :data="pmModCase">-->
                        <!--<span class="button" style="color:red;"> {{ pmModCase.casename }} </span>-->
                    <!--</div>-->
                    <!--<el-image-->
                            <!--:src=" $host + pmModCase.caseimg"-->
                            <!--:preview-src-list="srcList"-->
                            <!--lazy-->
                    <!--&gt;-->
                        <!--<div slot="error" class="image-slot" style="width: 100px; height: 100px; line-height: 100px; text-align: center; background-color: #f5f5f5;">-->
                            <!--<i class="el-icon-picture-outline"></i>-->
                        <!--</div>-->
                    <!--</el-image>-->
                <!--</el-card>-->
                <!--<el-card style="margin: 0 10px 10px 0;" :key="o.id" v-for="(o, index) in eleForm">-->
                    <!--<div style="padding: 14px;">-->
                        <!--<span class="button" style="color:red;"> {{ o.elementdesc }} </span>-->
                    <!--</div>-->
                    <!--<el-image-->
                            <!--:src=" $host + o.elementimg"-->
                            <!--:preview-src-list="srcList"-->
                            <!--lazy-->
                    <!--&gt;-->
                        <!--<div slot="error" class="image-slot" style="width: 100px; height: 100px; line-height: 100px; text-align: center; background-color: #f5f5f5;">-->
                            <!--<i class="el-icon-picture-outline"></i>-->
                        <!--</div>-->
                    <!--</el-image>-->
                <!--</el-card>-->
            <!--</div>-->

        </el-drawer>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="current"
                :page-size="size"
                :total="total">
        </el-pagination>
    </div>

</template>

<script>
    export default {
        name: 'Case',
        data () {
            return {
                fullscreenLoading: false,
                searchForm: {},
                delBtlStatu: true,
                total: 0,
                size: 10,
                current: 1,
                // editForm: {},
                tableData: [],
                tablePmModCaseInfoData: [],
                multipleSelection: [],
                drawer: false,
                direction: 'rtl',
                currentDate: new Date(),
                pmModCase: [],
                srcList: [],
                editForm: [],
                eleForm: []
            }
        },
        created () {
            this.getCaseList()
        },
        methods: {
            toggleSelection (rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row)
                    })
                } else {
                    this.$refs.multipleTable.clearSelection()
                }
            },
            handleSelectionChange (val) {
                console.log('勾选')
                console.log(val)
                this.multipleSelection = val
                this.delBtlStatu = val.length === 0
            },
            handleSizeChange (val) {
                console.log(`每页 ${val} 条`)
                this.size = val
                this.getCaseList()
            },
            handleCurrentChange (val) {
                console.log(`当前页: ${val}`)
                this.current = val
                this.getCaseList()
            },
            getCaseList () {
                this.$axios.get('/pm/case/all', {
                    params: {
                        casename: this.searchForm.casename,
                        current: this.current,
                        size: this.size
                    }
                }).then(res => {
                    this.tableData = res.data.data.records
                    console.log(res.data.data.records)
                    this.size = res.data.data.size
                    this.current = res.data.data.current
                    this.total = res.data.data.total
                })
            },
            editHandle (id) {
                this.$axios.get('/pm/case/info/' + id).then(res => {
                    console.log(res.data.data)
                    this.tablePmModCaseInfoData = res.data.data
                    this.pmModCase = res.data.data1
                    this.drawer = true
                    this.editForm = res.data.data
                    this.srcList.push(this.$host + res.data.data1.caseimg)
                    for (var key in this.editForm) {
                        if (this.editForm[key].elementimg !== null) {
                            this.eleForm.push(this.editForm[key])
                            this.srcList.push(this.$host + this.editForm[key].elementimg)
                        }
                    }
                })
            },
            runMode (id) {
                this.fullscreenLoading = true
                this.$axios.get('/pm/case/info/' + id, { timeout: 600000 }).then(res => {
                    this.fullscreenLoading = false
                    this.$message({
                        showClose: true,
                        message: '恭喜你，用例获取成功',
                        type: 'success',
                        onClose: () => {
                            let config = {
                                timeout: 600000,
                                header: {
                                    'Content-Type': 'application/json'
                                }
                            }
                            this.$axios.post('http://127.0.0.1:8098/handleDriver', {params: {
                                    url: res.data.data1.caseurl,
                                    casename: res.data.data.records
                                }}, config).then(res => {
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，用例开始运行',
                                    type: 'success'
                                })
                            })
                        }
                    })
                })
            },
            handleClose (done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.eleForm = []
                        this.srcList = []
                        done()
                    })
                    .catch(_ => {})
            },
            dateFormat (row, column) {
                var date = row[column.property]
                for (let i = 0; i < date.length; i++) {
                    if (date[i] < 10 && escape(date[i]).length === 1) {
                        let a = '0' + date[i]
                        date[i] = a
                    }
                }
                if (date === undefined) {
                    return ''
                }
                var yyyy = date[0]
                var MM = date[1]
                var dd = date[2]
                var HH = date[3]
                var mm = date[4]
                var ss = date[5]
                return yyyy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
            }
        }
    }
</script>

<style>

    .button {
        margin-bottom: 0;
        font-size: 24px;
        min-height: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 31px;
        margin-top: 5px;
        color: #87878a;
        white-space: normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/Result.vue